import { Pause, Play } from "lucide-react";
import { useMotionPref } from "@/context/MotionPref";

export default function MotionToggle({ className = "", testid = "motion-toggle" }) {
  const { paused, toggle } = useMotionPref();
  return (
    <button type="button" onClick={toggle} aria-pressed={paused} data-testid={testid}
      className={`inline-flex items-center gap-1.5 overline text-muted transition-colors hover:text-ink ${className}`}>
      {paused ? <Play className="h-3 w-3" aria-hidden /> : <Pause className="h-3 w-3" aria-hidden />}
      {paused ? "Play motion" : "Pause motion"}
    </button>
  );
}
